module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mrescir6-8bcc16e88c517fe727f23ad23726f842.jpg";